import Cookies from "js-cookie";
import qp from "query-parse";
import cookie from "../utils/cookie.json";
import Bus from "./bus";
let BUS = new Bus();

let instance = null;

class Discount {
  constructor() {
    if (!instance) {
      this.discount = 0;
      this.checkForDiscount();
      instance = this;
    }
    return instance;
  }

  amount() {
    return this.discount;
  }

  checkForDiscount() {
    if (typeof window === `undefined`) {
      return;
    }
    const search = window.location.search.slice(1);
    const queryObj = qp.toObject(search);
    if (queryObj.discount === "20OFF") {
      BUS.trigger("DISCOUNT_APPLIED");
      this.discount = 0.2;
      Cookies.get(cookie.discount_cookie) === undefined
        ? Cookies.set(cookie.discount_cookie, true, { expires: 1 })
        : Cookies.get(cookie.discount_cookie);
    }
    if (Cookies.get(cookie.discount_cookie) !== undefined) {
      this.discount = 0.2;
      BUS.trigger("DISCOUNT_APPLIED");
    }
  }
}
export default Discount;



// WEBPACK FOOTER //
// ./src/utils/discount.js